export const CAPTCHA_SITE_KEY = import.meta.env.VITE_CF_CAPTCHA_SITE_KEY;

export enum CaptchaStatus {
  HIDDEN = 'hidden',
  LOADING = 'loading',
  LOADED = 'loaded',
  SUCCESS = 'success',
}
